import React from "react";
import { Column } from "@ant-design/plots";

const LossBarChart = ({
  dataSource,
  newDataSource,
  formatType = "currency",
  allLabels = [],
}) => {
  const formatValue = (val) => {
    if (formatType === "percent") return `${val.toFixed(2)}%`;
    return val < 1000
      ? `$${val.toFixed(2)} Mil`
      : `$${(val / 1000).toFixed(2)} Bil`;
  };

  const chartData = [];

  allLabels.forEach((label) => {
    const base = newDataSource?.[label];
    const proj = dataSource?.[label];

    if (!base && !proj) return;

    chartData.push(
      {
        hazard: label,
        type: "Baseline Impact",
        value: base ? (formatType === "percent" ? base[2] : base[0]) : 0,
      },
      {
        hazard: label,
        type: "Projected Impact",
        value: proj ? (formatType === "percent" ? proj[2] : proj[0]) : 0,
      }
    );
  });
  const maxValue = Math.max(...chartData.map((item) => item.value), 0);
  const yAxisMax =
    formatType === "percent" ? Math.min(100, maxValue * 1.1) : maxValue * 1.1;

  const config = {
    data: chartData,
    isGroup: true,

    maxColumnWidth: 50,
    minColumnWidth: 50,
    xField: "hazard",
    yField: "value",
    seriesField: "type",
    columnStyle: {
      radius: [4, 4, 0, 0],
    },
    label: {
      position: "top",
      formatter: ({ value }) => value.toFixed(2),
      style: {
        fill: "#595959",
        fontSize: 12,
        fontWeight: 500,
      },
    },
    tooltip: {
      formatter: ({ value }) => ({
        name: "Value",
        value: value.toFixed(2), // 👈 Tooltip fixed to 2 decimals
      }),
    },
    legend: {
      position: "bottom",
    },
    xAxis: {
      label: {
        autoHide: false,
        autoRotate: false,
        style: {
          fill: "#595959",
          fontSize: 10.5,
        },
      },
    },

    yAxis: {
      min: 0,
      max: yAxisMax,
      label: {
        formatter: (val) =>
          formatType === "percent"
            ? `${val}%`
            : `$${parseFloat(val).toFixed(2)} Mil`,
      },
    },
    color: ({ type }) => (type === "Baseline Impact" ? "#BFCDF6" : "#1A3670"),
    height: 350,
    padding: "auto",
    geometryOptions: [
      {
        geometry: "interval",
        isGroup: true,
        seriesField: "type",
        intervalPadding: 16, // space between bars
        style: {
          width: 20, // 👈 Fixed bar width in pixels
        },
      },
    ],
  };

  return <Column {...config} />;
};

export default LossBarChart;
